/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DashboardReportScheduleRequest extends models.DashboardReportCreateRequest {
    getFixupPrototypeFunction() { return DashboardReportScheduleRequest.fixupPrototype; }

    static newInstance(model: Partial<DashboardReportScheduleRequest>): DashboardReportScheduleRequest {
        let obj = Object.assign(new DashboardReportScheduleRequest(), model);
        DashboardReportScheduleRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DashboardReportScheduleRequest>): DashboardReportScheduleRequest {
        if (!model) return null;
        return DashboardReportScheduleRequest.newInstance(<DashboardReportScheduleRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DashboardReportScheduleRequest) {
        if (!obj) return;

        models.DashboardReportScheduleRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DashboardReportScheduleRequest): boolean {
        if (models.DashboardReportCreateRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, DashboardReportScheduleRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * User ID of user who scheduled the report
     */
    user_id: string;

    /**
     * Schedule ID of which the report to be generated
     */
    schedule_id: string;

}
